/**
 * Área do PCP (Legado, ADR-0087): manuais das tarefas do PCP, editáveis pela
 * própria tela, e execução em checklist — um passo por vez, vários lotes
 * abertos ao mesmo tempo, funcionando também sem internet.
 *
 * Rotas em /legado/area-pcp/*. O provedor guarda o pacote no aparelho e a
 * fila de toques; cada tela lê dele.
 */
import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { PageLoader } from "../../components/LoadingMarcenaria";
import { useAuth } from "../../context/AuthContext";
import Busca from "./Busca";
import Editor from "./Editor";
import EmAndamento from "./EmAndamento";
import Execucao from "./Execucao";
import Historico from "./Historico";
import Manual from "./Manual";
import { AreaPcpProvider, useAreaPcp } from "./offline/AreaPcpContext";
import { PERM_EDITAR } from "./permissoes";
import Tarefas from "./Tarefas";

/** Em andamento abre primeiro quando há execução aberta; senão, Tarefas. */
function Inicio() {
  const { pacote } = useAreaPcp();
  if (!pacote) return <PageLoader scope="kpis" />;
  const abertas = (pacote.execucoes || []).length;
  return <Navigate to={abertas ? "em-andamento" : "tarefas"} replace />;
}

/**
 * Editor só para quem edita, e remontado a cada tarefa: ao criar, a rota vai
 * de /tarefas/nova para /tarefas/<id>/editar e o estado de "tarefa nova" não
 * pode sobreviver à troca.
 */
function EditorDaRota() {
  const { hasPermission } = useAuth();
  const { id } = useParams();
  if (!hasPermission(PERM_EDITAR)) return <Navigate to="/legado/area-pcp/tarefas" replace />;
  return <Editor key={id || "nova"} />;
}

export default function AreaPcp() {
  return (
    <AreaPcpProvider>
      <Routes>
        <Route index element={<Inicio />} />
        <Route path="em-andamento" element={<EmAndamento />} />
        <Route path="tarefas" element={<Tarefas />} />
        <Route path="tarefas/nova" element={<EditorDaRota />} />
        <Route path="tarefas/:id" element={<Manual />} />
        <Route path="tarefas/:id/editar" element={<EditorDaRota />} />
        <Route path="execucoes/:id" element={<Execucao />} />
        <Route path="historico" element={<Historico />} />
        <Route path="buscar" element={<Busca />} />
        <Route path="*" element={<Navigate to="/legado/area-pcp" replace />} />
      </Routes>
    </AreaPcpProvider>
  );
}
